/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const VendorErrorCategory = {
    CategoryUnknown: 'CATEGORY_UNKNOWN',
    Connectivity: 'CONNECTIVITY',
    PowerOps: 'POWER_OPS',
    AccessControl: 'ACCESS_CONTROL',
    EntryClosure: 'ENTRY_CLOSURE',
    SafetyAlarm: 'SAFETY_ALARM',
    Presence: 'PRESENCE',
    SystemHealth: 'SYSTEM_HEALTH',
    Maintenance: 'MAINTENANCE',
    Movement: 'MOVEMENT',
    Automation: 'AUTOMATION',
    EnergyBattery: 'ENERGY_BATTERY',
    FluidFlow: 'FLUID_FLOW',
    Thermal: 'THERMAL'
} as const;
export type VendorErrorCategory = typeof VendorErrorCategory[keyof typeof VendorErrorCategory];


export function instanceOfVendorErrorCategory(value: any): boolean {
    for (const key in VendorErrorCategory) {
        if (Object.prototype.hasOwnProperty.call(VendorErrorCategory, key)) {
            if (VendorErrorCategory[key as keyof typeof VendorErrorCategory] === value) {
                return true;
            }
        }
    }
    return false;
}

export function VendorErrorCategoryFromJSON(json: any): VendorErrorCategory {
    return VendorErrorCategoryFromJSONTyped(json, false);
}

export function VendorErrorCategoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): VendorErrorCategory {
    return json as VendorErrorCategory;
}

export function VendorErrorCategoryToJSON(value?: VendorErrorCategory | null): any {
    return value as any;
}

export function VendorErrorCategoryToJSONTyped(value: any, ignoreDiscriminator: boolean): VendorErrorCategory {
    return value as VendorErrorCategory;
}

